import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { Button } from 'ui-components/components/button';
import messages from '../../messages';
import { openProductDetailModal } from '../../../../store/products/products.actions';

const name = <FormattedMessage {...messages.skuColumnHeader} />;

const SKUColumn = ({ data }) => {
  const dispatch = useDispatch();
  const onClick = useCallback(() => {
    dispatch(openProductDetailModal(data.productId));
  }, [dispatch, data]);
  const sku = get(data, 'sku', '');
  return (
    <Button onClick={onClick} theme='link'>
      {sku}
    </Button>
  );
};

SKUColumn.propTypes = {
  data: PropTypes.shape({
    sku: PropTypes.string,
    productId: PropTypes.string,
  }).isRequired,
};

export default {
  getMessageDescriptor: () => messages.skuColumnHeader,
  name,
  render: (data) => <SKUColumn data={data} />,
};
